/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
//components
import CustomOptOutPageTable from './CustomOptOutPageTable'
import AddEditCustomPage from './AddEditCustomPage'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {RoutePaths} from '../../../routing/RoutePath'
//constants

const TemplateBredcrumb: Array<PageLink> = [
  {
    title: 'Home',
    path: '/custom-optout',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const CustomOptOutWrapper: FC = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <CustomOptOutPageTable />
            </>
          }
        />
        <Route
          path={RoutePaths.editCustomOpt}
          element={
            <>
              <AddEditCustomPage />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export {CustomOptOutWrapper}
